import React from 'react'

import '../styles/header.scss'

export default function Header(props){
    return(
        <div className="header">
            
            <div className="title-icon">
                <div className="title">
                    <button className="title-btn" onClick={props.onClick} value="remove-splash">Context Explorer NYC</button>
                </div>
                <div className="arrow-right"></div>
            </div>

            <ul>
                <li>
                    <button className="header-btn" onClick={props.onClick} value="add-splash">Introduction</button>
                </li>
                <li>
                    <button className="header-btn" onClick={props.onClick} value="remove-splash">Search</button>
                </li>
                <li>
                    <button className="header-btn" onClick={props.onClick} value="add-about">About</button>
                </li>
            </ul>
        </div>
    )
}